import { axiosAccess } from "@config/axiosConfig";

export const getActivityLogs = async (id: number) => {
  return await axiosAccess.post(`/activity-logs`, { application_id: id });
};